import { DEFAULT_ORG_SETTING_CHIP_STYLES, OrgSettingChipStyles } from './orgSettingChipStyles';

interface OrgSettingChipProps {
  orgName: string;
  enabled: boolean;
  onClick: () => void;
  styles?: OrgSettingChipStyles;
}

/** An org's name as a small clickable chip; its look and accessible name carry whether the supplier is enabled for it. */
export const OrgSettingChip = ({ orgName, enabled, onClick, styles = DEFAULT_ORG_SETTING_CHIP_STYLES }: OrgSettingChipProps) => {
  const state = enabled ? 'enabled' : 'disabled';
  return (
    <button type='button' css={[styles.root, styles.rootByState[state]]} aria-label={`${orgName}, ${state}`} title={`${orgName}: ${state}`} onClick={onClick}>
      {orgName}
    </button>
  );
};
